import { useSelector } from "react-redux";
import { MapPinIcon } from "lucide-react";
import { RootState } from "@store/reducers";

const LivePreview = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  // const { user } = useSelector((state: RootState) => state.auth);

  return (
    <div className="rounded-2xl bg-white flex flex-col flex-1 shrink-0 gap-4 px-5 pt-5 pb-10 h-max min-h-96">
      <div className="flex justify-between items-center h-max w-full">
        <div className="flex flex-col gap-1">
          <span className="font-bold text-primary">Live profile preview</span>
          <span className="text-sm text-light-black">
            Basic preview using details from steps 1 and 2 only.
          </span>
        </div>
        <div className="flex items-center justify-center rounded-full bg-blue-50 text-blue-600 h-max font-semibold text-xss px-2 py-0.5">
          Basic Profile
        </div>
      </div>

      <div className="rounded-md border p-4">
        <div className="flex gap-4">
          <div className="h-28 w-28 rounded-full border flex items-center justify-center bg-[#E2E8F0] border-[#95A9C4] overflow-hidden">
            {user?.profilePic ? (
              <img src={user?.profilePic} className="h-full w-full" />
            ) : (
              <span className="font-bold text-4xl text-primary">{user?.firstName?.charAt(0)}{user?.lastName?.charAt(0)}</span>
            )}
          </div>
          <div className="flex flex-col">
            <span className="font-bold uppercase text-2xl text-primary">{user?.firstName} {user?.lastName}</span>
            <span className="text-sm font-medium text-light-black mt-1">{user?.jobTitle}</span>
            <div className="flex items-center gap-1 mt-5">
              <MapPinIcon size={12} color="gray" />
              <span className="text-xss font-medium text-light-black">{user?.location}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default LivePreview;
